import React, { useState } from 'react'
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";



const Contact = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_85vncqh",
                "template_sh7wgvk",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>
            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Contact Us</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">Contact Us</li>
                    </ul>
                </div>
            </div>
            <div className="contact-area py-120">
                <div className="container">
                    <div className="contact-content">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="contact-info">
                                    <div className="contact-info-icon">
                                        <i className="fal fa-map-location-dot" />
                                    </div>
                                    <div className="contact-info-content">
                                        <h5>Office Address</h5>
                                        <Link to="https://share.google/Fsl3aMdnrCaBHv8Ae" target="_blank"><i className="far fa-location-dot" /> Swami Chowk, Mukhtiyarganj Satna (M.P.)</Link>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="contact-info">
                                    <div className="contact-info-icon">
                                        <i className="fal fa-phone-volume" />
                                    </div>
                                    <div className="contact-info-content">
                                        <h5>Call Us</h5>
                                        <Link to="tel:7987105491"><i className="far fa-phone-volume" /> +91 7987105491</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="contact-info">
                                    <div className="contact-info-icon">
                                        <i className="fal fa-envelopes" />
                                    </div>
                                    <div className="contact-info-content">
                                        <h5>Email Us</h5>
                                        <a href="mailto:pchs.satna@gmail.com"><i className="far fa-envelopes" /> pchs.satna@gmail.com</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="contact-info">
                                    <div className="contact-info-icon">
                                        <i className="fal fa-alarm-clock" />
                                    </div>
                                    <div className="contact-info-content">
                                        <h5>Open Time</h5>
                                        <p>Mon - Sat (09:00AM - 02:00PM)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-wrapper">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="contact-img">
                                    <img src="assets/school/contact_us.png" alt />
                                </div>
                            </div>
                            <div className="col-lg-7 align-self-center">
                                <div className="contact-form">
                                    <div className="contact-form-header">
                                        <h2>Fill in your details and we’ll call you back shortly.</h2>
                                        {/* <p>It is a long established fact that a reader will be distracted by the readable
                                            content of a page randomised words which don't look even slightly when looking at its layout. </p> */}
                                    </div>
                                    <form method="post" onSubmit={sendEmail} id="myForm">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Your Name"
                                                        name="from_name"
                                                        onChange={(e) => nameChange(e)}
                                                        required
                                                        value={name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input type="email" className="form-control" placeholder="Your Email"
                                                        id="email"
                                                        name='email'
                                                        onChange={(e) => mailChange(e)}
                                                        value={mail}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <input type="number" className="form-control" placeholder="Phone Number"
                                                id="phone"
                                                name='phone'
                                                onChange={(e) => numberChange(e)}
                                                value={number}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <textarea cols={30} rows={5} className="form-control" placeholder="Write Your Message"
                                                onChange={(e) => massagesChange(e)}
                                                name='massage'
                                                value={massages}
                                                required
                                            />
                                        </div>

                                        <button type="submit" className="theme-btn">Send Your Message <i className="far fa-paper-plane" /></button>
                                        <div className="col-md-12 mt-3">
                                            <div className="form-messege text-success" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-map" style={{marginTop:"-70px"}}>
                <iframe src="https://maps.google.com/maps?width=1600&height=600&hl=en&q=priyadarshani convent high school Swami Chowk, Mukhtiyarganj Satna (M.P.)&t=&z=14&ie=UTF8&iwloc=B&output=embed" style={{ border: 0 }} allowFullScreen loading="lazy" />
            </div>
            <br />
            <br />
            <br />
        </>
    )
}

export default Contact